// imports
import { FC } from 'react';
import { Alert, Box, CircularProgress, Grid, Typography } from '@mui/material';

// components
import { PlanCard } from 'components/main/Plans/PlanCard';

// constants, interfaces, themes
import { ERROR_LOADING_PLANS, FETCHING_PLANS_TEXT } from 'constants/constant';
import { RenderPlanCardsProps } from 'interfaces';
import { flexColCenter } from 'theme/styleConstant';

export const RenderPlanCards: FC<RenderPlanCardsProps> = ({ loading, error, prices, currentPlanId }) => {
  if (loading) {
    return (
      <Box sx={{ ...flexColCenter, gap: 3, py: 6 }}>
        <CircularProgress size={50} thickness={4} />
        <Typography variant="body1">{FETCHING_PLANS_TEXT}</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ ...flexColCenter, gap: 3, py: 6 }}>
        <Alert severity="error">{ERROR_LOADING_PLANS}</Alert>
      </Box>
    );
  }

  return (
    <Grid container spacing={4}>
      {prices?.map((item) => {
        const { id, product, interval, amount } = item || {};

        return (
          <Grid item xs={12} sm={6} key={id}>
            <PlanCard
              priceId={id}
              product={product}
              interval={interval}
              amount={amount}
              disabled={id === currentPlanId}
              isModal
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
